import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";

import "swiper/css";
import "swiper/css/pagination";

import { PreviewContainer } from "../styled/setting";
import FilePreview from "../../../../common/filePreview";

const Preview = ({ company = null, image = null, info = null, objectFit = "cover" }) => {
  return (
    <PreviewContainer className={objectFit}>
      <div className="company">
        {image && image.length > 0 ? (
          <Swiper className="mySwiper" loop modules={[Pagination]} pagination={{ clickable: true }}>
            {(image || []).map((item) => (
              <SwiperSlide key={item.id}>
                <div className="box">
                  <FilePreview item={item} />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <img src="/img/shop_main_bg3.jpg" />
        )}
        <p>{info}</p>
      </div>
      {(company?.cmpnySe || company?.cmpnyBadgeText?.length > 0) && (
        <div className="tags">
          {company?.cmpnySe && <strong>{company.cmpnySe}</strong>}
          {(company?.cmpnyBadgeText || []).map((badge) => (
            <span className="badge" key={badge.badgeName}>
              {badge}
            </span>
          ))}
        </div>
      )}
    </PreviewContainer>
  );
};

export default Preview;
